import ReactGA from "react-ga4";

export default function analyticEvent(category,action) {
  ReactGA.event({
    category: category,
    action: action,
  });
}